import { useRecoveryAccountContext } from "../../../Contexts/RecoveryAccountContext";
import Button from "../../../Components/Button";

const MaxicareCardSuccess = () => {
  const { navigate } = useRecoveryAccountContext();

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 rounded-xl sm:mt-24 ">
        <div className="flex flex-col sm:items-center justify-center p-4">
          <div className="mt-52 sm:mt-0 flex flex-col items-center justify-center text-center px-6">
            <img
              src={require("../../../assets/success.png")}
              alt="Personal"
              className="w-24 h-24 flex justify-center"
            />
          </div>
          <div className="text-2xl text-center font-semibold">
            Mobile number updated successfully
          </div>

          <div className=" text-center mx-3 text-[#60656D]">
            Your mobile number has been successfully updated. You may now log in
            using this new mobile number
          </div>
        </div>

        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3 mt-2">
          <Button
            className="h-12 w-full transition ease-in-out delay-75 rounded-xl text-white"
            onClick={() => navigate("/", { replace: true })}
          >
            Go to home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaxicareCardSuccess;
